import { render, staticRenderFns } from "./ViewAllProductsList.vue?vue&type=template&id=c8c3ce9a"
import script from "./ViewAllProductsList.vue?vue&type=script&lang=js"
export * from "./ViewAllProductsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports